import type { ReactNode } from "react";

import { Text } from "@alpacahq/ui/old";

interface RowProps {
  label: string;
  children: ReactNode;
}

export const Row = ({ label, children }: RowProps) => (
  <div className="flex w-full items-start justify-between gap-4">
    <Text className="text-gray-500 text-sm">{label}</Text>
    <div className="font-medium text-gray-700 text-sm">{children}</div>
  </div>
);
